(function ($) {

	$(document).ready(function () {
		$('.answer__text').hide();

		$('.dialogue .toggle_answer').on('click', function (event) {

			// Stop the anchor behavior.
			event.preventDefault();

			$('html, body').animate({
				scrollTop: $(this).parent().parent().parent().parent().offset().top - 50
			}, 'slow');

			$(this).parent().parent().prev().slideToggle('slow', function () {
				var dialogue = $(this).next();
				var arrow = dialogue.find('.angle');
				var span = dialogue.find('span');

				if ($(this).is(':visible')) {
					arrow.toggleClass('fa-angle-double-down');
					arrow.toggleClass('fa-angle-double-up');
					span.text('Hide the answer');
				} else {
					
					// Remove the anchor when hiding the answer.
					location.hash.replace('#', '');
					location.hash = '';

					// Swap out the link.
					arrow.toggleClass('fa-angle-double-up');
					arrow.toggleClass('fa-angle-double-down');
					span.text('Show the answer');
				}
			});
		});

		//Footer nav dropdown
        var toggleSwitch = false;
        var toogleDelay = 0;

        $( ".has-dropdown > a" )
            .click(function(event){
                //event.preventDefault();
            });
        $( ".has-dropdown" ).hover(function() {
            var that = this;
            toggleSwitch = !toggleSwitch;

            if (toggleSwitch) {
                $(that).find('> .menu-dropdown').fadeIn();
                $(that).addClass('dropdown-active');
            } else {
                $(that).find('> .menu-dropdown').fadeOut();
                $(that).removeClass('dropdown-active');
            }
        });
	});
})(jQuery);
